export function commonFunc() {
	updateDotNavigation();
	document.addEventListener('scroll', updateDotNavigation);
	smoothAnkerLink();
}

/**
 * ナビゲーション更新
 */
function updateDotNavigation() {
	const sections = document.querySelectorAll('.section');
	const dots = document.querySelectorAll('.dot');

	sections.forEach((section, index) => {
		const top = section.getBoundingClientRect().top;
		if (top < window.innerHeight / 2 && top > -window.innerHeight / 2) {
			dots[index].classList.add('active');
		} else {
			dots[index].classList.remove('active');
		}
	})
}

/**
 * アンカーリンクにスムーススクロールを追加
 * CSSだけだとchromeで動作しなかったため
 */
function smoothAnkerLink() {
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();
			const target = document.querySelector(this.getAttribute('href'));

			// スクロールスナップを無効化
			document.getElementById('fullpage').style.scrollSnapType = 'none';

			// スムーススクロールを実行
			target.scrollIntoView({ behavior: 'smooth' });

			// スクロール終了後にスナップを再有効化
			setTimeout(() => {
				document.getElementById('fullpage').style.scrollSnapType = 'y mandatory';
			}, 1000); // スクロール時間を考慮
		});
	});
}
